import { RootState } from "../../reducers";

export const unsavedDocumentChangesSelector = (state: RootState): boolean =>
  state.saving.openSaveDialog;

export const unsavedClientChangesSelector = (state: RootState): boolean =>
  state.saving.openClientDialog;
